import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "portalId", "assignmentIds", "children", "textAlign", "tooltipPlacement", "render", "use"];
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { AssignPlaylistModalTrigger } from './AssignPlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssignPlaylistButton = _ref => {
  let {
      playlistId,
      portalId,
      assignmentIds,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlistAssignments.assignPlaylist"
      }),
      textAlign = 'center',
      tooltipPlacement,
      render,
      use = 'tertiary-light'
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = useCallback(() => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: assignmentIds ? 'playlist-due-date-update' : 'assign-playlist-clicked',
      playlistId,
      portalId
    });
  }, [assignmentIds, playlistId, portalId]);
  return /*#__PURE__*/_jsx(AssignPlaylistModalTrigger, {
    assignmentIds: assignmentIds,
    playlistId: playlistId,
    portalId: portalId,
    renderTrigger: ({
      openModal
    }) => {
      const handleClickWithAnalytics = () => {
        handleClick();
        openModal();
      };
      if (render) {
        return render(handleClickWithAnalytics);
      }
      return /*#__PURE__*/_jsx(Tooltip, {
        placement: tooltipPlacement,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.playlistAssignments.assignPlaylistTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
          onClick: handleClickWithAnalytics,
          use: use,
          children: /*#__PURE__*/_jsx(View, {
            inlineSize: "100%",
            textAlign: textAlign,
            children: children
          })
        }))
      });
    }
  });
};